"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IconPicker_1 = require("./IconPicker");
(function (w, $) {
    if (!$)
        return false;
    var iconPickerExtensions = {
        iconPicker: function () {
            return this.each(function () {
                var obj = $(this);
                new IconPicker_1.IconPicker(obj);
            });
        }
    };
    $.fn.extend(iconPickerExtensions);
})(window, $);
